// opened by handleBlockNavigation() of inboxpage/InboxCompose.js
// opened by handleBlockNavigation() of conversationpage/EditMessageForm
// 2 buttons: cancel the navigation or discard the changes and continue to next location
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { closeModal } from '../../actions';
import {
  closeModalType,
  handleGoToNextLocationType,
  classesType
} from '../../types';

const styles = {
  buttons: {
    paddingBottom: '1rem'
  }
};

const UnsubmittedMessageModal = props => {
  const handleDiscardChanges = () => {
    props.handleGoToNextLocation();
    props.closeModal();
  };

  return (
    <Dialog
      open
      onClose={props.closeModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="form-dialog-title">Unsaved Changes</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Do you want to discard these changes?
        </DialogContentText>
      </DialogContent>
      <DialogActions className={props.classes.buttons}>
        <Button
          onClick={props.closeModal}
          // color="primary"
          // variant="contained"
        >
          Cancel
        </Button>
        <Button
          onClick={handleDiscardChanges}
          color="primary"
          variant="contained"
        >
          Discard Message
        </Button>
      </DialogActions>
    </Dialog>
  );
};

UnsubmittedMessageModal.propTypes = {
  closeModal: closeModalType.isRequired,
  handleGoToNextLocation: handleGoToNextLocationType.isRequired,
  classes: classesType.isRequired
};

const actions = { closeModal };

const enhance = compose(connect(null, actions), withStyles(styles));

export default enhance(UnsubmittedMessageModal);
